var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iban-input"},[_c('b-field',{attrs:{"label":"IBAN","type":{ 'is-danger': _vm.hasError },"message":_vm.errorMessage}},[_c('div',{attrs:{"id":"iban-element"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }